import {IconWifiOff} from '@tabler/icons-react';
import type {FC, ReactNode} from 'react';
import {NoItemsPanel} from 'src/design/molecules/NoItemsPanel';

export interface OfflinePlaceholderProps {
  heading: string;
  text: string;
  cta?: ReactNode;
}

// Guidance screen shown in place of surfaces that need a connection.
export const OfflinePlaceholder: FC<OfflinePlaceholderProps> = ({
  heading,
  text,
  cta,
}) => (
  <NoItemsPanel
    icon={<IconWifiOff size={48} />}
    heading={heading}
    noItemsText={text}
    canCreate={cta ? true : undefined}
    createNode={cta}
  />
);
